import { AnimateSharedLayout, motion } from 'framer-motion'
import { useRef, useState, useEffect } from 'react'

import { Control, useFieldArray } from 'react-hook-form'
import { DAYS, TIMES } from '../../Constants'
import AddMore from '../Buttons/AddMore'
import RemoveButton from '../Buttons/RemoveButton'
import Select from '../Select'

export type BuinessHoursType = {
  day: string
  to: string
  from: string
}
interface BusinessHoursInterface {
  control: Control<Record<string, any>>
  name: string
  register: Function
}

const BusinessHours = ({ control, name, register }: BusinessHoursInterface) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name
  })
  const ref = useRef<HTMLDivElement>(null)
  const getDimensions = () => ({
    width: ref?.current?.offsetWidth ?? 0,
    height: ref?.current?.offsetHeight ?? 0
  })

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions())
    }

    if (ref) {
      setDimensions(getDimensions())
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [ref])

  useEffect(() => {
    if (!fields?.length) {
      append({})
    }
  }, [fields])

  return (
    <div className="wc-responsive-table wc-business-hours__table" ref={ref}>
      {dimensions.width < 600 ? (
        <AnimateSharedLayout>
          <motion.div layout>
            {(fields as Record<string, any>).map(
              ({ id, day, from, to }, index) => (
                <motion.div
                  layout
                  key={`contacts${id}`}
                  style={{
                    background:
                      index % 2 !== 0 ? '#fff' : 'rgba(0, 107, 166, 0.1)',
                    padding: 10,
                    marginBottom: 10
                  }}
                >
                  <div>
                    <Select
                      id={`business_hours_day_${index}`}
                      label="Day"
                      options={DAYS}
                      register={register}
                      name={`business_hours[${index}].day`}
                      defaultValue={day}
                    />
                  </div>
                  <div>
                    <Select
                      id={`business_hours_from_${index}`}
                      label="From"
                      options={TIMES}
                      register={register}
                      name={`business_hours[${index}].from`}
                      defaultValue={from}
                    />
                  </div>
                  <div>
                    <Select
                      id={`business_hours_to_${index}`}
                      label="To"
                      options={TIMES}
                      register={register}
                      name={`business_hours[${index}].to`}
                      defaultValue={to}
                    />
                  </div>
                  <div className="flex flex-col">
                    <RemoveButton
                      id={String(id)}
                      handleRemove={() => remove(index)}
                      isDisabled={fields.length <= 1}
                    />
                  </div>
                </motion.div>
              )
            )}
          </motion.div>
        </AnimateSharedLayout>
      ) : (
        <table>
          <thead>
            <tr>
              <th scope="col">Day</th>
              <th scope="col">From</th>
              <th scope="col">To</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <AnimateSharedLayout>
            <motion.tbody layout>
              {(fields as Record<string, any>).map(
                ({ id, day, from, to }, index) => (
                  <motion.tr
                    layout
                    key={`business_hours${id}`}
                    data-testid="row"
                  >
                    <td>
                      <Select
                        id={`business_hours_day_${index}`}
                        options={DAYS}
                        register={register}
                        name={`business_hours[${index}].day`}
                        defaultValue={day}
                        show="empty"
                      />
                    </td>
                    <td>
                      <Select
                        id={`business_hours_from_${index}`}
                        options={TIMES}
                        show="time"
                        register={register}
                        name={`business_hours[${index}].from`}
                        defaultValue={from}
                      />
                    </td>
                    <td>
                      <Select
                        id={`business_hours_to_${index}`}
                        options={TIMES}
                        show="time"
                        register={register}
                        name={`business_hours[${index}].to`}
                        defaultValue={to}
                      />
                    </td>
                    <td>
                      <RemoveButton
                        id={String(id)}
                        handleRemove={() => remove(index)}
                        isDisabled={fields.length <= 1}
                      />
                    </td>
                  </motion.tr>
                )
              )}
            </motion.tbody>
          </AnimateSharedLayout>
        </table>
      )}
      <div
        className={dimensions.width < 600 ? '' : 'wc-business-hours__add-more'}
      ></div>
      <AddMore handleClick={() => append({})} />
    </div>
  )
}

export default BusinessHours
